import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { QuartzJobMonitor } from '../../../models/QuartzJobMonitor/QuartzJobMonitor';

export const GetQuartzJobs = createAsyncThunk(
    'quartzMonitor/getQuartzJobs',
    async (_, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get('/api/Maintenance/quartz-jobs');

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch Quartz jobs at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch Quartz jobs');
            }

            return { jobs: response.data as QuartzJobMonitor[] };
        } catch (error) {
            createNotification(
                'An error occurred while fetching Quartz jobs.',
                'error'
            );
            throw error;
        }
    }
);
